import React from 'react';
import styles from './StatusFilter.module.css';
import { CCI_JOB_STATUSES, cciStatusLabel } from './cciStatus';

// Toggle chips, one per job status; `selected` is the list of statuses shown
export default function StatusFilter({ selected, onChange }) {
  const toggle = (status) => {
    const next = selected.includes(status)
      ? selected.filter((s) => s !== status)
      : CCI_JOB_STATUSES.filter((s) => s === status || selected.includes(s));
    onChange(next);
  };

  return (
    <div className={styles.row} role="group" aria-label="Filter by status">
      {CCI_JOB_STATUSES.map((status) => (
        <button
          key={status}
          type="button"
          className={styles.chip}
          aria-pressed={selected.includes(status)}
          onClick={() => toggle(status)}
        >
          {cciStatusLabel(status)}
        </button>
      ))}
    </div>
  );
}
